<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined :color="color" class="ml-3">
        <v-icon>{{ icon }}</v-icon
        ><span v-if="edit === false">Contrato</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col sm="12">
              <v-text-field
                label="N° do contrato"
                name="nome"
                type="text"
                required
                v-model="payload.numContrato"
                :rules="[obrigatorio]"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <ComboboxUser
                ref="user"
                :filter="payload"
                :rules="[obrigatorio, naoHabilitado]"
                :returnObject="true"
              ></ComboboxUser>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="payload.inicio"
                v-mascara="'##/##/####'"
                label="Data Início "
                placeholder="00/00/0000"
                hide-details="auto"
                :rules="rulesData"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="payload.fim"
                v-mascara="'##/##/####'"
                label="Data Final"
                placeholder="00/00/0000"
                hide-details="auto"
                :rules="rulesData"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                label="Quantidade de entregas previstas"
                name="nome"
                type="number"
                required
                :rules="[obrigatorio]"
                v-model="payload.qtdEntregasPrevistas"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                label="Quantidade de horas previstas"
                name="nome"
                type="number"
                required
                v-model="payload.qtdHorasPrevistas"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-currency-field
                label="Valor Hora"
                :prefix="'R$'"
                filled
                v-model="payload.valorHora"
                hide-details="auto"
              />
            </v-col>
            <v-col>
              <v-autocomplete
                v-model="payload.natureza"
                label="Natureza do contrato"
                :items="naturezas"
                hide-details="auto"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                label="Objeto"
                v-model="payload.descricao"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-file-input
                label="Contrato"
                v-model="payload.arquivo"
                @change="(_) => (payload.nomeArquivo = null)"
                accept="application/pdf"
              >
              </v-file-input>
            </v-col>
          </v-row>
          <v-row v-if="payload.nomeArquivo">
            <v-col>
              <v-btn color="info" outlined text @click="downloadArquivo">{{
                payload.nomeArquivo
              }}</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="close()">Fechar</v-btn>
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ComboboxUser from "@/modules/user/components/ComboboxUsers";
import { dataRegexValidatior } from "@/helpers/validator";
import { mapActions, mapGetters } from "vuex";
import { contratosAPI } from "@/apis";

import moment from "moment";
export default {
  name: "ModalInsertContrato",
  props: {
    object: { type: Object, required: false },
    edit: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true },
  },
  components: {
    ComboboxUser,
  },
  data() {
    return {
      payload: {},
      dialog: false,
      obrigatorio: (v) => !!v || "Campo Obrigatório",
      naoHabilitado: (v) => {
        return (v && !!v.habilitado) || "Usuário não habilitado";
      },

      naturezas: ["Consultoria", "Instrutoria", "Consultoria e Instrutoria"],
      rulesData: [
        (v) => {
          if (!v) return true;
          if (!dataRegexValidatior.test(v)) {
            return "Data inválida";
          }
          return true;
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  watch: {
    dialog(item) {
      this.payload = {};

      if (item) {
        if (this.object && this.edit === true) {
          this.payload = {
            ...this.object,
            usuarioId: this.object.usuario,
            inicio: moment(this.object.inicio, "YYYY-MM-DD").format(
              "DD/MM/YYYY"
            ),
            fim: moment(this.object.fim, "YYYY-MM-DD").format("DD/MM/YYYY"),
          };
        }
      }
    },
  },
  methods: {
    ...mapActions(["setLoading"]),

    downloadArquivo() {
      contratosAPI
        .downloadContrato(this.payload.contratoId)
        .then((resp) => {
          let blob = new Blob([resp.data], {
            type: resp.headers["content-type"],
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.target = "_blank";
          link.download = this.payload.nomeArquivo + ".pdf";
          link.click();

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter anexo");
        });
    },
    async check() {
      if (!this.$refs.form) return true;
      const isValid = await this.$refs.form.validate();
      const isValidGrupo = await this.$refs.user.check();
      return isValid && isValidGrupo;
    },
    async onConfirm() {
      const valid = await this.check();
      if (!valid) return;

      this.setLoading(true);

      let formData = new FormData();
      formData.append("numContrato", this.payload.numContrato);
      formData.append("usuarioid", this.payload.usuarioId.usuarioId);
      formData.append(
        "inicio",
        this.payload.inicio
          ? moment(this.payload.inicio, "DD/MM/YYYY").format("YYYY-MM-DD")
          : ""
      );
      formData.append(
        "fim",
        this.payload.fim
          ? moment(this.payload.fim, "DD/MM/YYYY").format("YYYY-MM-DD")
          : ""
      );
      formData.append(
        "qtdEntregasPrevistas",
        this.payload.qtdEntregasPrevistas
      );
      formData.append(
        "qtdHorasPrevistas",
        this.payload.qtdHorasPrevistas ? this.payload.qtdHorasPrevistas : 0
      );
      formData.append(
        "valorHora",
        this.payload.valorHora ? this.payload.valorHora : 0
      );
      formData.append(
        "descricao",
        this.payload.descricao ? this.payload.descricao : ""
      );
      formData.append("arquivo", this.payload.arquivo);
      formData.append("dataAlteracao", moment().format("YYYY-MM-DD"));
      formData.append("usuarioCriacao", this.user.usuarioId);
      formData.append("ativo", true);
      formData.append("natureza", this.payload.natureza);

      if (this.edit === true) {
        formData.append("contratoId", this.payload.contratoId);

        contratosAPI
          .update(formData)
          .then((resp) => {
            this.dialog = false;
            this.$emit("on-save");
          })
          .catch();
      } else {
        contratosAPI
          .create(formData)
          .then((resp) => {
            this.dialog = false;
            this.$emit("on-save");
          })
          .catch();
      }
    },
    close() {
      if (!this.object && this.edit !== true) {
        this.payload = {};
      }

      this.dialog = false;
    },
  },
};
</script>
